import { useEffect } from 'react'

import { useCaseFactsStore } from '../stores/caseFacts'

export const useCaseFacts = () => useCaseFactsStore((state) => state.facts)

export const useCaseFactsActions = () =>
  useCaseFactsStore((state) => state.actions)

export const useCaseFactMutations = () =>
  useCaseFactsStore((state) => state.mutations)

export const useFetchCaseFacts = (slug: string) => {
  const { fetchCaseFacts } = useCaseFactsStore((state) => state.loaders)
  const { reset } = useCaseFactsStore((state) => state.actions)

  useEffect(() => {
    fetchCaseFacts(slug)
    return reset
  }, [slug, fetchCaseFacts, reset])
}
